(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-payout-header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-payout-header.js');

'use strict';

var _svs$lyckoplatsen$dat;
const charityPayoutPageInfo = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data.cms) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.charityPayoutPageInfo;
const {
  CmsTextFormatter
} = svs.lyckoplatsen.shared_utils.react.components;
const CharityPayoutHeader = () => React.createElement("div", {
  className: "charity-payout-header charity-grid ".concat(charityPayoutPageInfo === null || charityPayoutPageInfo === void 0 ? void 0 : charityPayoutPageInfo.color)
}, React.createElement("h1", {
  className: "padding-top-3 margin-bottom-1 charity-grid-body f-900"
}, charityPayoutPageInfo === null || charityPayoutPageInfo === void 0 ? void 0 : charityPayoutPageInfo.textTitle), React.createElement("p", {
  className: "f-500 charity-grid-body"
}, React.createElement(CmsTextFormatter, {
  text: charityPayoutPageInfo === null || charityPayoutPageInfo === void 0 ? void 0 : charityPayoutPageInfo.textDescription
})));
setGlobal('svs.lyckoplatsen.components.page_charity_payout.react.components', {
  CharityPayoutHeader
});

 })(window);